<template>
  <div style="height: 100%">
    <div style="width: 200px; position: absolute; z-index: 20">
      <Float_menu />
    </div>
    <div
      ref="DC_env_all"
      :style="{
        height: '100%',
        backgroundImage: 'url(' + this.backgroud_png + ') ',
        backgroundSize: 'center',
        backgroundPosition: 'cover',
      }"
    ></div>
  </div>
</template>

  <script>
import * as echarts from "echarts";
// import { getTopoData } from "../utils/topo_utils";
import { Url, grafana_Url, tooltip_basecss } from "../config/env";
import Float_menu from "../views/Float_menu";

export default {
  data() {
    return {
      mychartOptions: {},
      chartWidth: 1920,
      chartHeight: 920,
      backgroud_png: Url + "/topo_data/DC_env_all/bg.png",
      symbolSizeTimes: 1,
      envData: {
        colors: {
          status_colors: ["#4301E6", "orange", "#DC251F"],
          border_colors: ["grey", "orange"],
          text_colors: ["#aaa", "orange"],
        },
        lineTag: {
          c_1g: {
            lineColor: "#666",
            lineWidth: 5,
            lineType: "dashed",
          },
          f_1g: {
            lineColor: "orange",
            lineWidth: 5,
            lineType: "dashed",
          },
          f_10g: {
            lineColor: "red",
            lineWidth: 5,
            lineType: "dashed",
          },
        },
        nodeSymbolsize: {
          ac: [50, 50],
          tmp: [50, 50],
          ups: [50, 50],
          door: [50, 50],
          water: [50, 50],
          camera: [50, 50],
          smoke: [50, 50],
          bat: [50, 50],
          mdc: [50, 50],
        },
      },
    };
  },
  components: {
    Float_menu,
  },
  // watch: {
  //   chartWidth(chartWidth) {
  //     this.symbolSizeTimes = (this.chartWidth / 1720).toFixed(1);
  //   },
  // },
  methods: {
    getTopoData: async function (topo_name, env_Data) {
      let options = {};
      //获取全局变量
      const status_colors = env_Data.colors.status_colors;
      var border_colors = env_Data.colors.border_colors;
      // 获取图中主机数据
      const hosts_file = Url + "topo_data/" + topo_name + "/hosts_obj.json";
      const lines_file = Url + "topo_data/" + topo_name + "/lines_obj.json";
      // const borders_file = Url + "topo_data/" + topo_name + "/borders_obj.json";
      const borders1_file =
        Url + "topo_data/" + topo_name + "/borders1_obj.json";
      // const [hosts_data, lines_data, borders_data, borders1_data] =
      const [hosts_data, lines_data, borders1_data] = await Promise.all([
        fetch(hosts_file),
        fetch(lines_file),
        // fetch(borders_file),
        fetch(borders1_file),
      ]);
      const hostsData = await hosts_data.json();
      const linesData = await lines_data.json();
      // const bordersData = await borders_data.json();
      const bordersData1 = await borders1_data.json();
      const hosts = hostsData["data"];
      const lines = linesData["data"];
      // const borders = bordersData["data"];
      const borders1 = bordersData1["data"];
      let charts = {
        hosts: [],
        lines: [],
        lines_1: [],
        // borders: [],
        borders1: [],
      };
      //  生成节点数据
      for (let key in hosts) {
        //定义tooltip中的信息
        let tooltip_info = "信息暂无";
        // let problem_info = "系统正常"
        let tooltip_list = hosts[key]["item_info"];
        let problem_obj = hosts[key]["problems"];
        if (Object.keys(tooltip_list).length != 0) {
          tooltip_info = "";
          for (let item of tooltip_list) {
            tooltip_info +=
              '<div><span style="color:gray">' +
              Object.keys(item) +
              "&nbsp" +
              '</span>:<span style="color:#1a9b97">' +
              "&nbsp" +
              Object.values(item) +
              "</></div>";
          }
        }
        //加入故障信息
        if (Object.keys(problem_obj).length != 0) {
          tooltip_info += "<div>当前系统存在告警信息如下:</div>";
          let n = 1;
          for (let i in problem_obj) {
            if (problem_obj[i]["priority"] <= 3) {
              tooltip_info +=
                '<div style="color:orange">' +
                n +
                "." +
                "&nbsp" +
                problem_obj[i]["name"] +
                "</div>";
              n += 1;
            } else {
              tooltip_info +=
                '<div style="color:red">' +
                n +
                "." +
                problem_obj[i]["name"] +
                "</div>";
              n += 1;
            }
          }
        } else {
          tooltip_info += '<div style="color:#1a9b97">系统正常</div>';
        }
        let node = {
          name: hosts[key]["id"],
          label: hosts[key]["nodeName"],
          value: hosts[key]["coords"],
          //新增用于node排序的ID
          ID: key,
          symbolSize: [
            this.envData.nodeSymbolsize[hosts[key]["pngPath"]][0] *
              this.symbolSizeTimes,
            this.envData.nodeSymbolsize[hosts[key]["pngPath"]][1] *
              this.symbolSizeTimes,
          ],
          // symbolSize: hosts[key]["symbolSize"].split(","),
          // symbolSize: [65, 65],
          nodeStatus: hosts[key]["nodeStatus"],
          symbol:
            "image://" +
            Url +
            "/topo_data/" +
            topo_name +
            "/" +
            hosts[key]["pngPath"] +
            "_" +
            hosts[key]["nodeStatus"] +
            ".png",
          // itemStyle: {
          //   color: status_colors[hosts[key]["nodeStatus"]],
          // },
          // label: {
          //     show: hosts[key]["labelShow"] == true,
          //     position: "bottom",
          //     color: "#4301E6",
          //     fontFamily: "Arial",
          //     fontSize: 15,
          //     formatter: hosts[key]["nodeName"]
          // },
          tooltip: tooltip_info,
          url1:
            hosts[key]["url1"][0] == "#"
              ? Url + hosts[key]["url1"]
              : grafana_Url[hosts[key]["url1"]] +
                "&var-HOST=" +
                hosts[key]["zabbix_hostname"],
          click_redirect: "true",
        };
        charts.hosts.push(node);
      }
      console.log(charts.hosts);
      //  生成边框1数据
      for (let key in borders1) {
        let line = {
          lineName: borders1[key]["borderName"],
          // coords: [lines[key]['source']['croods'] || lines[key]['source'], lines[key]['target']['croods'] || lines[key]['target']],
          coords: borders1[key]["coords"],
          lineStyle: {
            color: borders1[key]["borderColor"],
            width: 5,
            // opacity: 0.3,
          },
          url1: "#/DC_env_all",
          click_redirect: "true",
          // label: {
          //   show: true,
          //   position: "start",
          //   color: "#666",
          //   fontFamily: "serif",
          //   fontWeight: "bold",
          //   fontSize: 15,
          //   formatter: "aaa",
          //   // formatter: function (item) {
          //   //   return borders1[key]["borderName"];
          //   // },
          // },
        };
        charts.borders1.push(line);
      }
      return charts;
    },
    makeChartOption(chartData) {
      let options = {
        // backgroundColor: "#000000",
        grid: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          // width: 1720,
          // height: 900,
        },
        xAxis: {
          min: 0,
          max: this.chartWidth,
          show: false,
          type: "value",
        },
        yAxis: {
          min: 0,
          max: this.chartHeight,
          show: false,
          inverse: true,
          type: "value",
        },
        tooltip: tooltip_basecss,
        graphic: {
          // id: "aa",
          elements: [
            {
              type: "text",
              left: "7%",
              top: "10%",
              style: {
                text: "门诊综合楼5F中心机房",
                font: "normal bolder 30px 'Gill Sans', sans-serif",
                // lineWidth: 45,
                fill: this.envData.colors.text_colors[0],
              },
              silent: true,
            },
            {
              type: "text",
              left: "7%",
              top: "39%",
              style: {
                text: "住院①3F汇聚机房",
                font: "normal bolder 30px 'Gill Sans', sans-serif",
                // lineWidth: 45,
                fill: this.envData.colors.text_colors[0],
              },
              silent: true,
            },
            {
              type: "text",
              left: "7%",
              top: "69%",
              style: {
                text: "感染楼1F汇聚机房",
                font: "normal bolder 30px 'Gill Sans', sans-serif",
                // lineWidth: 45,
                fill: this.envData.colors.text_colors[0],
              },
              silent: true,
            },
            {
              type: "text",
              left: "55.5%",
              top: "10%",
              style: {
                text: "综合楼5F容灾机房",
                font: "normal bolder 30px 'Gill Sans', sans-serif",
                // lineWidth: 45,
                fill: this.envData.colors.text_colors[0],
              },
              silent: true,
            },
            {
              type: "text",
              left: "64.5%",
              top: "39.5%",
              style: {
                text: "住院②1F物联网机房",
                font: "normal bolder 30px 'Gill Sans', sans-serif",
                // lineWidth: 45,
                fill: this.envData.colors.text_colors[0],
              },
              silent: true,
            },
            {
              type: "text",
              left: "54%",
              top: "69%",
              style: {
                text: "住院③1F汇聚机房",
                font: "normal bolder 30px 'Gill Sans', sans-serif",
                // lineWidth: 45,
                fill: this.envData.colors.text_colors[0],
              },
              silent: true,
            },
          ],
        },
        series: [
          ///节点数据
          {
            type: "graph",
            coordinateSystem: "cartesian2d",
            // roam: true,
            layout: "none",
            emphasis: {
              // disabled: true,
              scale: 1.4,
              // focus: 'self',
              // blurScope: 'global'
            },
            label: {
              show: true,
              position: "bottom",
              color: this.envData.colors.text_colors[0],
              fontFamily: "serif",
              fontWeight: "bold",
              fontSize: 15,
              formatter: function (item) {
                return item.data.label;
              },
            },
            data: chartData.hosts,
            // zoom: 2,
            zlevel: 3,
          },
          //边框信息
          {
            type: "lines",
            polyline: true,
            coordinateSystem: "cartesian2d",
            // colorBy: "white",
            tooltip: {
              show: false,
              position: function (point) {
                return point[0];
              },
              color: "red",
              formatter: function (item) {
                return item.data.lineName;
              },
            },
            // emphasis: {
            //   // disabled: false,

            //   // focus: 'self',
            //   // blurScope: 'global',
            //   lineStyle: {
            //     type: "solid",
            //     width: 5,
            //     // curveness: 0.1,
            //   },
            // },
            lineStyle: {
              // type: 5,
              cap: "round",
              type: "solid",
              width: 2,
            },
            emphasis: {
              disabled: false,
              width: 2,
              lineStyle: {
                // type: 5,
                cap: "round",
                type: "solid",
                width: 4,
              },
            },
            data: chartData.borders1,
            zlevel: 1,
          },
        ],
      };
      return options;
    },
    maketopo: async function (topo_name) {
      let myChart = echarts.init(this.$refs[topo_name]);
      //获取数据
      let myChartData = await this.getTopoData(topo_name, this.envData);
      //定义options
      this.mychartOptions = this.makeChartOption(myChartData);
      //渲染页面
      myChart.setOption(this.mychartOptions);
      // //故障节点动画效果
      setInterval(() => {
        for (let i in this.mychartOptions.series[0].data) {
          if (this.mychartOptions.series[0].data[i]["nodeStatus"] != 0) {
            this.mychartOptions.series[0].data[i]["symbolSize"][0] *= 1.2;
            this.mychartOptions.series[0].data[i]["symbolSize"][1] *= 1.2;
          }
        }
        myChart.setOption(this.mychartOptions);
        setTimeout(() => {
          for (let i in this.mychartOptions.series[0].data) {
            if (this.mychartOptions.series[0].data[i]["nodeStatus"] != 0) {
              this.mychartOptions.series[0].data[i]["symbolSize"][0] /= 1.2;
              this.mychartOptions.series[0].data[i]["symbolSize"][1] /= 1.2;
            }
          }
          myChart.setOption(this.mychartOptions);
        }, 1000);
      }, 2000);
      //判断单击or双击
      let click_type = null; // 定义一个定时器
      myChart.on("click", (data) => {
        if (!click_type) {
          click_type = setTimeout(() => {
            window.location.assign(data.data.url1);
            click_type = null; // 清除定时器
          }, 300);
        } else {
          window.open(data.data.url2);
          clearTimeout(click_type); // 清除定时器
          click_type = null;
        }
      });
      //轮播tooltip
      let index = 0; //高亮所在下标
      let dataLength = this.mychartOptions.series[0].data.length; // 当前饼图有多少个扇形
      let mTime = setInterval(() => {
        myChart.dispatchAction({
          type: "downplay", // seriesIndex: 0, //里层的圆形
          dataIndex: index % dataLength,
        });
        index++;
        myChart.dispatchAction({
          type: "highlight", // seriesIndex: 0,
          dataIndex: index % dataLength,
        });
        myChart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: index % dataLength,
        });
        // console.log(this.mychartOptions.series[0].data[index]);
      }, 1000);
      //  鼠标划入
      myChart.on("mouseover", (e) => {
        // 停止定时器，清除之前的高亮
        clearInterval(mTime);
        myChart.dispatchAction({
          type: "downplay", // seriesIndex: 0 //清一下高亮
        });
        myChart.dispatchAction({
          type: "highlight", // seriesIndex: 0,
          dataIndex: e.dataIndex, //当前鼠标选中的高亮
        });
      });
      myChart.on("mouseout", (e) => {
        clearInterval(mTime);
        myChart.dispatchAction({
          type: "downplay", // seriesIndex: 0,
          dataIndex: e.dataIndex,
        }); //鼠标移出后先把上次的高亮取消
        mTime = setInterval(() => {
          // 取消高亮指定的数据图形
          myChart.dispatchAction({
            type: "downplay", // seriesIndex: 0,
            dataIndex: index % dataLength,
          });
          index++;
          // 高亮指定的数据图形
          myChart.dispatchAction({
            type: "highlight", // seriesIndex: 0,
            dataIndex: index % dataLength,
          });
          myChart.dispatchAction({
            type: "showTip",
            seriesIndex: 0,
            dataIndex: index % dataLength,
          });
        }, 10000);
      });
      //自动刷新
      setInterval(async () => {
        this.mychartOptions = this.makeChartOption(
          await this.getTopoData("DC_env_all", this.envData)
        );
        // myChart.setOption(this.mychartOptions);
      }, 60000);
      //自动变化窗口大小
      window.onresize = function () {
        myChart.resize();
        this.chartWidth = myChart.getDom().clientWidth;
        this.chartHeight = myChart.getDom().clientHeight;
      };
    },
  },
  mounted() {
    this.maketopo("DC_env_all");
  },
};
</script>
  <style lang="less" scoped>
@import "../style/mixin";
</style>
  
